export default __webpack_public_path__ + "b902e59aed87dbc80e7b7ddd42b5e0fb.png";